
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-support-ai-agent",
      function () {
        return require("private-next-pages/customer-support-ai-agent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-support-ai-agent"])
      });
    }
  